import t from"react";import{mdiTrayArrowUp as o}from"@mdi/js";import{MdIcon as r}from"./MdIcon.js";const e=({id:e="upload",title:i="Upload",...m})=>t.createElement(r,{id:e,title:i,path:o,...m});export{e as UploadIcon};
